import { createPluginFactory } from "@udecode/plate-core";

export const ELEMENT_VIDEO = "video";

export const createVideoPlugin = createPluginFactory<any>({
    key: ELEMENT_VIDEO,
    isElement: true,
    isVoid: true,
    then: (editor, { type }) => ({
        deserializeHtml: {
            rules: [
                {
                    validNodeName: "VIDEO",
                },
            ],
            getNode: (el) => ({
                type,
                // url: el.getAttribute('src'),
            }),
        },
    }),
});
